(function ($) {
  document.addEventListener('DOMContentLoaded', () => {
    const ctaSingle = document.querySelectorAll('.courses-workshops-list__element');

    if (!ctaSingle.length) {
      return;
    }

    document.querySelector('#main-content').classList.add('has-related-courses');

    ctaSingle.forEach(element => {
      const description = element.querySelector('.desc');
      
      if (!description) {
        return;
      }

      description.style.setProperty('--element-height', description.scrollHeight + 'px');
    });
  });
})(jQuery);